import { FOOTER } from "@/constants/testIds/site";

const items = [
  "10 Year Protection",
  "Official Ritec Applicator",
  "20 Years Experience",
  "UK-Wide On-Site Service",
  "Showers · Conservatories · Windows",
  "Limescale Resistant",
  "Hydrophobic Coating",
];

export default function Footer() {
  return (
    <footer
      data-testid={FOOTER.root}
      className="relative bg-emerald-950 text-white overflow-hidden"
    >
      {/* Marquee ribbon */}
      <div className="border-y border-white/10 py-6 overflow-hidden">
        <div className="marquee-track flex whitespace-nowrap gap-12 text-lg font-display font-light tracking-wide opacity-80">
          {[...items, ...items, ...items].map((it, i) => (
            <span key={i} className="flex items-center gap-12">
              {it}
              <span className="text-emerald-400">◆</span>
            </span>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-2xl overflow-hidden ring-2 ring-emerald-400/40">
              <img src="/j7-logo.png" alt="J7 Collective" className="w-full h-full object-cover" />
            </div>
            <div>
              <div className="font-display text-2xl font-semibold leading-tight">
                J7 Collective Ltd
              </div>
              <div className="text-[10px] font-bold tracking-widest uppercase text-emerald-300">
                Glass Surface Protection Specialists
              </div>
            </div>
          </div>
          <p className="mt-5 text-white/70 leading-relaxed max-w-sm">
            On‑site ClearShield application by a Ritec‑trained team of
            applicators with 20 years of experience. Glass protection, done
            properly.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs font-bold tracking-widest uppercase text-emerald-300">
            Explore
          </div>
          <ul className="mt-4 space-y-2 text-white/80">
            <li><a href="#about" className="hover:text-emerald-300">About</a></li>
            <li><a href="#services" className="hover:text-emerald-300">Services</a></li>
            <li><a href="#how-it-works" className="hover:text-emerald-300">How it works</a></li>
            <li><a href="#booking" className="hover:text-emerald-300">Booking</a></li>
            <li><a href="#contact" className="hover:text-emerald-300">Contact</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs font-bold tracking-widest uppercase text-emerald-300">
            Contact
          </div>
          <ul className="mt-4 space-y-2 text-white/80">
            <li><a href="tel:+447497498669" className="hover:text-emerald-300">Mobile · 07497 498669</a></li>
            <li><a href="tel:+442030518827" className="hover:text-emerald-300">Office · 020 3051 8827</a></li>
            <li><a href="mailto:J7GLASS@hotmail.com" className="hover:text-emerald-300 break-all">J7GLASS@hotmail.com</a></li>
            <li>United Kingdom · On‑site service</li>
            <li>Mon–Sat · 8am – 6pm</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 py-6 text-center text-xs text-white/50 px-6">
        © {new Date().getFullYear()} J7 Collective Ltd · <a href="https://j7glass.co.uk" className="hover:text-emerald-300">j7glass.co.uk</a> · Glass Surface Protection Specialists · ClearShield Applicator. ClearShield® is a product of Ritec. All rights reserved.
      </div>
    </footer>
  );
}
